import { useEffect, useState } from 'react';
import { subscribePrinters, type PrinterListResult } from '@/lib/firestorePrinters';

/**
 * Hook que envolve `subscribePrinters` em estado React. Retorna `LOADING` no
 * primeiro tick, `READY`/`ERROR` em seguida. Limpa o listener no unmount e
 * quando `tenantId` muda. *
 * Origem: sem issue — commit a55e77f4c, 2026-06-10 14:05 +0200 (aba Impressoras
 * read-only).
 *
 * Usado por: `features/printers/PrintersTab.tsx`.
 *
 * Dados: `tenants/{tenantId}/printers` por `name asc`, validado por
 * `PrinterProfileSchema` em `lib/firestorePrinters.ts`. Só leitura — o admin
 * não escreve perfil de impressora.
 *
 * Falhas conhecidas: documento fora do schema é descartado no `lib/` só com
 * `console.warn`, e erro do listener só com `console.error` — nenhum dos dois
 * chega à telemetria (CLAUDE.md "Observabilidade"; ver #926, achados).
 */
export function usePrinters(tenantId: string): PrinterListResult {
  const [result, setResult] = useState<PrinterListResult>({ kind: 'LOADING' });

  useEffect(() => {
    if (!tenantId) {
      setResult({ kind: 'LOADING' });
      return;
    }
    setResult({ kind: 'LOADING' });
    const unsub = subscribePrinters(tenantId, setResult);
    return unsub;
  }, [tenantId]);

  return result;
}
